import { LifeTimeMode } from "../dto/License";

export const toUtcIso = (dateStr: string, mode: LifeTimeMode, time?: string): Date => {
    const [year, month, day] = dateStr.split("-").map(Number);

    if (mode === "start")
    {
        return new Date(Date.UTC(year, month - 1, day, 0, 0, 0, 0));
    }
    else if (mode === "end")
    {
        return new Date(Date.UTC(year, month - 1, day, 23, 59, 59, 999));
    }
    else if (mode === "exact")
    {
        const parsedTime = time?.split(":").filter(v => !!v).map(v => parseInt(v)) ?? [];
        const hours = parsedTime.length > 0 && !isNaN(parsedTime[0]) ? parsedTime[0] : 0;
        const minutes = parsedTime.length > 1 && !isNaN(parsedTime[1]) ? parsedTime[1] : 0;
        const seconds = parsedTime.length > 2 && !isNaN(parsedTime[2]) ? parsedTime[2] : 0;
        const milliseconds = parsedTime.length > 3 && !isNaN(parsedTime[3]) ? parsedTime[3] : 0;

        return new Date(Date.UTC(year, month - 1, day, hours, minutes, seconds, milliseconds));
    }
    else
    {
        const now = new Date();
        return new Date(Date.UTC(year, month - 1, day, now.getUTCHours(), now.getUTCMinutes(), now.getUTCSeconds(), now.getUTCMilliseconds()));
    }
};

export const addToUtcDate = (base: Date, { days = 0, weeks = 0, months = 0, years = 0 }) =>
{
    const result = new Date(base.getTime());

    if (years)
    {
        result.setUTCFullYear(result.getUTCFullYear() + years);
    }
    if (months)
    {
        result.setUTCMonth(result.getUTCMonth() + months);
    }
    if (weeks)
    {
        days += weeks * 7;
    }
    if (days)
    {
        result.setUTCDate(result.getUTCDate() + days);
    }

    return result;
};